import { useCallback, useEffect, useState } from 'react'
import { api } from './api'
import type { FieldSeason } from './types'

export type FieldSeasonInput = {
  previousCrop: string | null
  currentCrop: string | null
  variety: string | null
  datePlanted: string | null
}

/** The season header (CanadaGAP H1/H2 form header) for one field and crop year. */
export function useFieldSeason(orgId: string | undefined, farmId: string | undefined, fieldId: string | undefined, seasonYear: number) {
  const [season, setSeason] = useState<FieldSeason | null>(null)
  const base = orgId && farmId ? `/orgs/${orgId}/farms/${farmId}/spray-log-field-seasons` : null

  const load = useCallback(async () => {
    if (!base || !fieldId) return
    setSeason(await api.get<FieldSeason | null>(`${base}/${fieldId}/${seasonYear}`))
  }, [base, fieldId, seasonYear])

  useEffect(() => {
    load().catch(() => setSeason(null))
  }, [load])

  async function saveSeason(input: FieldSeasonInput) {
    if (!base || !fieldId) return
    setSeason(await api.put<FieldSeason>(base, { fieldId, seasonYear, ...input }))
  }

  return { season, saveSeason }
}
